import { inject } from '@angular/core';
import { withDevtools } from '@angular-architects/ngrx-toolkit';
import { patchState, signalStore, withMethods, withProps, withState } from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { combineLatest, pipe, switchMap, tap } from 'rxjs';

import { Competition } from '@/shared/models/competitions.interface';
import { PhasesMasters } from '@/shared/models/phasesMasters.model';
import { Season } from '@/shared/models/season.model';
import { CompetitionsService } from '@/shared/services/competitions.service';
import { PhasesMastersService } from '@/shared/services/phasesMasters.service';
import { SeasonsService } from '@/shared/services/seasons.service';

import { MainStore } from './main-store';

export interface MasterDataState {
  tags: PhasesMasters[];
  seasons: Season[];
  competitions: Competition[];
  // Añadir más masters aquí:
  // roleMasters: RoleMaster[];
  // positionMasters: PositionMaster[];
  isLoading: boolean;
  error: string | null;
}

const initialState: MasterDataState = {
  tags: [],
  seasons: [],
  competitions: [],
  // Añadir más masters aquí:
  // roleMasters: [],
  // positionMasters: [],
  isLoading: false,
  error: null,
};

export const MasterDataStore = signalStore(
  { providedIn: 'root' },
  withDevtools('masterData'),
  withState(initialState),

  withProps(() => ({
    mainStore: inject(MainStore),
    phasesMastersService: inject(PhasesMastersService),
    seasonssService: inject(SeasonsService),
    competitionsService: inject(CompetitionsService),
    // Añadir más servicios aquí:
    // roleMastersService: inject(RoleMastersService),
    // positionMastersService: inject(PositionMastersService),
  })),

  withMethods((store) => ({
    loadAllMasters: rxMethod<void>(
      pipe(
        tap(() => {
          patchState(store, { isLoading: true, error: null });
        }),
        switchMap(() => {
          return combineLatest({
            tags: store.phasesMastersService.getPhasesMasters(),
            seasons: store.seasonssService.getSeasons(),
            competitions: store.competitionsService.getCompetitions({}),
            // Añadir más llamadas aquí:
            // roleMasters: store.roleMastersService.getRoleMasters(),
            // positionMasters: store.positionMastersService.getPositionMasters(),
          });
        }),
        tap({
          next: (results) => {
            patchState(store, {
              tags: results.tags,
              seasons: results.seasons,
              competitions: results.competitions,
              // Añadir más resultados aquí:
              // roleMasters: results.roleMasters,
              // positionMasters: results.positionMasters,
              isLoading: false,
              error: null,
            });
          },
          error: (error) => {
            patchState(store, {
              isLoading: false,
              error: error?.message || 'Error loading master data',
            });
          },
        })
      )
    ),
    getCompetitionsBySeason(seasonId: number): Competition[] {
      return store.competitions().filter((comp: Competition) => comp.seasonId === seasonId);
    },
  }))
);
